import { Route } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { HowItWorksComponent } from '../common/how-it-works/how-it-works.component';
import { OverviewComponent } from '../common/overview/overview.component';
import { PlayerActivityMyProgressComponent } from './player-activity-my-progress/player-activity-my-progress.component';
import { PlayerActivityPageComponent } from './player-activity-page/player-activity-page.component';
import { PlayerActivityResultsComponent } from './player-activity-results/player-activity-results.component';

export const PlayerActivityRoutes: Route[] = [
    {
        path: '',
        data: routeData({ authorized: true }),
        component: PlayerActivityPageComponent,
        children: [
            {
                path: 'myprogress',
                data: routeData({ authorized: true }),
                component: PlayerActivityMyProgressComponent,
            },
            {
                path: 'overview',
                data: routeData({ authorized: true }),
                component: OverviewComponent,
            },
            {
                path: 'howitworks',
                data: routeData({ authorized: true }),
                component: HowItWorksComponent,
            },
            {
                path: 'results',
                data: routeData({ authorized: true }),
                component: PlayerActivityResultsComponent,
            },
        ],
    },
];
